import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnInit,
  inject,
} from '@angular/core';
import { Store } from '@ngxs/store';
import { COMPACT_SHIFT_HEIGHT, ItemViewModel } from '@wilson/interfaces';
import {
  GanttEndingPixelPipe,
  GanttStartingPixelPipe,
  ShiftCardTooltipStateService,
  ShiftValidationTooltipWrapperComponent,
  TimeDifferenceWidthPxPipe,
  ValidationDataSourceService,
} from '@wilson/shift-timeline/assignments-gantt-chart';
import { ShiftTimelinePipesModule } from '@wilson/shift-timeline/pipes';
import { DragAndDropModeService } from '@wilson/shift-timeline/services';
import { ActivitiesRowComponent } from '../activities-row/activities-row.component';
import { FindStaffValidationDataSourceService } from '../services/find-staff-validation-data-source.service';

@Component({
  selector: 'wilson-shift-to-assign-card',
  templateUrl: './shift-to-assign-card.component.html',
  styleUrls: ['./shift-to-assign-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    ShiftCardTooltipStateService,
    {
      provide: ValidationDataSourceService,
      useClass: FindStaffValidationDataSourceService,
    },
  ],
  imports: [
    CommonModule,
    ShiftValidationTooltipWrapperComponent,
    ShiftTimelinePipesModule,
    GanttStartingPixelPipe,
    GanttEndingPixelPipe,
    TimeDifferenceWidthPxPipe,
    ActivitiesRowComponent,
  ],
})
export class ShiftToAssignCardComponent implements OnInit {
  private store = inject(Store);
  readonly dragAndDropModeService = inject(DragAndDropModeService);
  readonly cdRef = inject(ChangeDetectorRef);
  readonly shiftCardTooltipStateService = inject(ShiftCardTooltipStateService);

  @Input() shiftView!: ItemViewModel | undefined;
  @Input() isHovered = false;
  @Input() userId!: string | undefined;
  @Input() isActivitiesView!: boolean;

  MIN_WIDTH_PX = 110;
  FIRST_BREAKPOINT = 100;
  SECOND_BREAKPOINT = 65;

  defaultShiftHeight = COMPACT_SHIFT_HEIGHT;
  plannedShiftStartDateTime!: string;
  plannedShiftEndDateTime!: string;

  ngOnInit() {
    if (this.shiftView && this.userId) {
      this.plannedShiftStartDateTime =
        this.shiftView.shift.activities[0].startDatetime;
      this.plannedShiftEndDateTime =
        this.shiftView.shift.activities[
          this.shiftView.shift.activities.length - 1
        ].endDatetime;
      this.shiftCardTooltipStateService.initState(
        this.userId,
        this.shiftView.shift,
      );
    }
  }
}
